
import {AuthenticationGateway} from "./authentication.gateway";
import {LoginController} from "./login/login.controller";
import { AuthenticationService, IAuthenticationService } from "./authentication.service";



export default angular.module('idi.marketplace.authentication', ['core'])
.service('authenticationGateway', AuthenticationGateway)
.service('authenticationService', AuthenticationService)
.controller("login.controller", LoginController)
.config(routeConfig)
.run(moduleRun)
.name;

routeConfig.$inject = ['$stateProvider'];

function routeConfig($stateProvider: ng.ui.IStateProvider): void {
    $stateProvider
        .state('shellFrame.authenticationFrame.login',
            {
                url: '/login',
                templateUrl: 'modules/authentication/login/login.view.html',
                controller: 'login.controller',
                controllerAs: 'vm',
                resolve: {} ,  
                data: { claimsProfile: { allowAnonymousAccess: true}},
                params: {appState:''}
            }).state('shellFrame.identityCallback', {
                url: 'callback',
                controller: 'callback.controller',
                templateUrl: 'modules/authentication/callback/callback.view.html',
                controllerAs: 'vm',
                resolve: {},
                data: {claimsProfile: { allowAnonymousAccess: true}}
              });
}
       

moduleRun.$inject = ['authenticationService'];

function moduleRun(authenticationService: IAuthenticationService): void{

    if(authenticationService.isAuthenticated()){
        authenticationService.checkForToken();
    }
    
 }